module.exports = __webpack_public_path__ + "static/Neutraface-Slab-Text-Bold-18a872a98d4ba6c5518e46aea5512f6e.otf";